export const CLIENT = 'client'
export const CLIENT_BEST_WALLET = 'bestwallet'
